import RippleEffect from './RippleEffect';

export default RippleEffect;
